export const MessageTypes = Object.freeze({
    Text: "text",
    Audio: "audio",
    Image: "image",
    Reply: "reply",
    Video: "video",
    Order: "order",
    Interactive: "interactive",
    ReplyToItem: "replyToItem",
    Document: "document",
    Location: "location",
    Template: "template",
    Button: "button"
});

export const InteractiveSubtypes = Object.freeze({
    PaymentSummary: "cta_url",
    Catalog: "catalog_message",
    Product: "product",
    Products: "product_list",
    InteractiveButtons: "button",
    ButtonReply: "button_reply",
    Flow: "flow",
    nfmReply: "nfm_reply",
});

export const SupportedTypes = Object.freeze({
    Text: "text",
    Audio: "audio",
    Image: "image",
    Order: "order",
    Document: "document",
    Location: "location",
    PaymentDetails: "paymentDetails",
    Template: "template",
    NotSupported: "not Supported",
    NotLoaded: "not Loaded",
});

export const PaymentStatuses = Object.freeze({
    success: "SUCCESS",
    fail: "FAILED",
});

export const InvoiceStatus = Object.freeze({
    success: "Paid",
    pending: "pending",
});

export const OrderStatuses = Object.freeze({
    pending: "Pending",
    drafted: "Drafted",
    current: "Current",
    cancelled: "Cancelled",
    done: "Done",
    reverseInProgress: "ReverseInProgress",
    inDelivery: "InDelivery",
    ready: "Ready",
});

export const PaymentStatus = Object.freeze({
    Paid: "Paid",
    Valid: "Valid",
    Expired: "Expired",
    Generate: "Generate",
});

export const MessageStatus = Object.freeze({
    DELIVERED: 'delivered',
    FAILED: 'failed',
    SENT: 'sent',
    READ: 'read',
    PENDING: 'pending'
});
